import { BaseMenuItem } from '../BaseMenuItem/BaseMenuItem';
import { MenuItemProps } from './MenuItem.types';

/**
 * The `MenuItem` control that wraps our `BaseMenuItem` control. We redefine `classes`
 * to be `className` on this wrapper so that classNames can only target the root property
 * of the `classes` MUI prop.
 *
 * @param className - {@link MenuItemProps.className className} description.
 * @param value - {@link MenuItemProps.value value} description.
 * @param dataValue - {@link MenuItemProps dataValue} description.
 * @param selected - {@link MenuItemProps.selected selected} description.
 * @param ariaSelected - {@link MenuItemProps ariaSelected} description.
 * @param onClick - {@link MenuItemProps.onClick onClick} description.
 * @param onKeyUp - {@link MenuItemProps.onKeyUp onKeyUp} description.
 * @param children - {@link MenuItemProps.children children} description.
 */
const MenuItem = ({
    className,
    value,
    'data-value': dataValue,
    selected,
    'aria-selected': ariaSelected,
    onClick,
    onKeyUp,
    children,
}: MenuItemProps) => {
    return (
        <BaseMenuItem
            classes={{
                root: className,
            }}
            selected={selected}
            aria-selected={ariaSelected}
            value={value}
            data-value={dataValue}
            onClick={onClick}
            onKeyUp={onKeyUp}
        >
            {children}
        </BaseMenuItem>
    );
};

export default MenuItem;